/**
 * Password Meter - vanilla JS widget for Blade password forms.
 *
 * Mirrors the auth password policy used by Vue auth screens.
 */
$(document).ready(function () {
    const SEQUENCES = [
        '1234','2345','3456','4567','5678','6789','7890','0123',
        'abcd','bcde','cdef','defg','efgh','fghi','ghij','hijk',
        'ijkl','jklm','lmno','mnop','nopq','opqr','pqrs',
        'qrst','rstu','stuv','tuvw','uvwx','vwxy','wxyz',
        'qwer','asdf','zxcv'
    ];

    const ICON_CIRCLE = '<svg class="password-meter__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/></svg>';
    const ICON_CHECK  = '<svg class="password-meter__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';

    function normalizedPersonalValue(value, minLength) {
        const normalized = String(value || '').trim().toLowerCase();
        return normalized.length > minLength ? normalized : '';
    }

    function emailPrefix(value) {
        const prefix = String(value || '').trim().toLowerCase().split('@')[0] || '';
        return prefix.length > 3 ? prefix : '';
    }

    function personalEmailPrefix(value) {
        return normalizedPersonalValue(String(value || '').split('@')[0], 2);
    }

    function checkRules(password, $form) {
        const lp = password.toLowerCase();
        const personalValues = [
            emailPrefix($form.find('input[name="email"]').val()),
            normalizedPersonalValue($form.find('input[name="first_name"]').val(), 2),
            normalizedPersonalValue($form.find('input[name="last_name"]').val(), 2),
            normalizedPersonalValue($form.find('input[name="name"]').val(), 2),
            normalizedPersonalValue($form.find('input[name="contact_name"]').val(), 2),
            personalEmailPrefix($form.find('input[name="contact_email"]').val()),
        ].filter(Boolean);

        return {
            hasMinLength: password.length >= 15,
            hasMaxLength: password.length <= 64,
            hasPrintableAsciiOnly: /^[\x20-\x7E]*$/.test(password),
            hasNoSequentialCharacters: !SEQUENCES.some(s => lp.includes(s)),
            hasNoRepeatedCharacters: !/(.)(\1){3,}/.test(password),
            hasNoPlatformName: !lp.includes('remoni'),
            hasNoPersonalData: !personalValues.some(value => lp.includes(value)),
        };
    }

    function calcStrength(rules) {
        const values = Object.values(rules);
        const passed = values.filter(Boolean).length;

        if (passed === values.length) return 3;
        if (passed >= Math.ceil(values.length / 2)) return 2;
        return 1;
    }

    function barClass(strength, barIndex) {
        if (strength >= barIndex) {
            if (strength === 1) return 'password-meter__bar--weak';
            if (strength === 2) return 'password-meter__bar--medium';
            if (strength === 3) return 'password-meter__bar--strong';
        }
        return '';
    }

    $('.js-password-meter').each(function () {
        const $meter   = $(this);
        const $bars    = $meter.find('.js-password-meter-bar');
        const $tooltip = $meter.find('.js-password-meter-tooltip');
        const $rules   = $meter.find('.js-password-meter-rule');
        const inputSelector = $meter.data('password-input');
        const $input = inputSelector
            ? $(inputSelector)
            : $meter.closest('.profile-form-groups, .profile-form, .row').find('input[name="password"]');

        if (!$input.length) return;

        $input.on('input', function () {
            const password = $(this).val();

            if (!password) {
                this.setCustomValidity('');
                $tooltip.hide();
                $bars.each(function () {
                    $(this).attr('class', 'password-meter__bar js-password-meter-bar');
                });
                return;
            }

            $tooltip.show();

            const rules = checkRules(password, $input.closest('form'));
            const strength = calcStrength(rules);
            const isValid = Object.values(rules).every(Boolean);

            this.setCustomValidity(isValid ? '' : 'Please meet all password requirements.');

            $bars.each(function (i) {
                const cls = barClass(strength, i + 1);
                $(this).attr('class', 'password-meter__bar js-password-meter-bar ' + cls);
            });

            const ruleKeys = [
                'hasMinLength',
                'hasMaxLength',
                'hasPrintableAsciiOnly',
                'hasNoSequentialCharacters',
                'hasNoRepeatedCharacters',
                'hasNoPlatformName',
                'hasNoPersonalData',
            ];

            $rules.each(function (i) {
                const key = ruleKeys[i];
                if (!key) return;

                const pass = rules[key];
                $(this).toggleClass('password-meter__rule--pass', pass);
                $(this).find('.js-password-meter-icon').html(pass ? ICON_CHECK : ICON_CIRCLE);
            });
        });

        $input.closest('form').find([
            'input[name="email"]',
            'input[name="first_name"]',
            'input[name="last_name"]',
            'input[name="name"]',
            'input[name="contact_name"]',
            'input[name="contact_email"]',
        ].join(',')).on('input', function () {
            $input.trigger('input');
        });
    });
});
